package org.example.project.model

import kotlinx.serialization.Serializable
import org.example.project.util.currentTimeMillis

@Serializable
data class MultiplayerGame(
    val gameId: String = "",
    val player1Uid: String = "",
    val player2Uid: String = "",
    val player1Name: String = "",
    val player2Name: String = "",
    val status: String = "SHIP_PLACEMENT",
    val currentTurnUid: String = "",
    val winnerUid: String = "",
    val player1Ready: Boolean = false,
    val player2Ready: Boolean = false,
    val player1Ships: List<SerializedShip> = emptyList(),
    val player2Ships: List<SerializedShip> = emptyList(),
    val attacksOnPlayer1: List<String> = emptyList(),
    val attacksOnPlayer2: List<String> = emptyList(),
    val player1Score: Int = 0,
    val player2Score: Int = 0,
    val player1Penalties: Int = 0,
    val player2Penalties: Int = 0,
    val player1Correct: Int = 0,
    val player2Correct: Int = 0,
    val player1Charges: AttackCharges = AttackCharges(),
    val player2Charges: AttackCharges = AttackCharges(),
    val lastEvent: String = "",
    val countdownStart: Double = 0.0,
    val turnStartTime: Double = 0.0,
    val placementStartTime: Double = 0.0,
    val player1TimerMode: TimerMode = TimerMode.NONE,
    val player2TimerMode: TimerMode = TimerMode.NONE,
    val player1QuestionStart: Double = 0.0,
    val player2QuestionStart: Double = 0.0,
    val player1TurnTimerStart: Double = 0.0,
    val player2TurnTimerStart: Double = 0.0
) {
    fun opponentUid(myUid: String): String =
        if (myUid == player1Uid) player2Uid else player1Uid

    fun opponentName(myUid: String): String =
        if (myUid == player1Uid) player2Name else player1Name

    fun myName(myUid: String): String =
        if (myUid == player1Uid) player1Name else player2Name

    fun isPlayer1(uid: String): Boolean = uid == player1Uid

    fun myShips(uid: String): List<SerializedShip> =
        if (isPlayer1(uid)) player1Ships else player2Ships

    fun opponentShips(uid: String): List<SerializedShip> =
        if (isPlayer1(uid)) player2Ships else player1Ships

    fun attacksOnMe(uid: String): List<String> =
        if (isPlayer1(uid)) attacksOnPlayer1 else attacksOnPlayer2

    fun attacksOnOpponent(uid: String): List<String> =
        if (isPlayer1(uid)) attacksOnPlayer2 else attacksOnPlayer1

    fun myScore(uid: String): Int =
        if (isPlayer1(uid)) player1Score else player2Score

    fun myPenalties(uid: String): Int =
        if (isPlayer1(uid)) player1Penalties else player2Penalties

    fun myCorrect(uid: String): Int =
        if (isPlayer1(uid)) player1Correct else player2Correct

    fun myCharges(uid: String): AttackCharges =
        if (isPlayer1(uid)) player1Charges else player2Charges

    fun isMyTurn(uid: String): Boolean =
        currentTurnUid == uid && status == "BATTLE"

    fun opponentTimerMode(myUid: String): TimerMode =
        if (isPlayer1(myUid))
            player2TimerMode
        else
            player1TimerMode

    fun opponentTimerStart(myUid: String): Double =
        if (isPlayer1(myUid)) {
            if (player2TimerMode == TimerMode.TURN) {
                player2TurnTimerStart
            } else {
                player2QuestionStart
            }
        }

        else{
            if(player1TimerMode == TimerMode.TURN){
                player1TurnTimerStart
            }else {
                player1QuestionStart
            }

        }

    fun bothReady(): Boolean = player1Ready && player2Ready

    fun secondsRemaining(): Int {
        val elapsed =
            ((currentTimeMillis() - turnStartTime) / 1000).toInt()

        return (120 - elapsed).coerceAtLeast(0)
    }

    fun placementSecondsRemaining(): Int {

        val elapsed =
            ((currentTimeMillis() - placementStartTime) / 1000).toInt()

        return (90 - elapsed).coerceAtLeast(0)
    }
}

// Legacy alias kept for any remaining references
typealias Game = MultiplayerGame
